import { html, LitElement, nothing } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from './styles.js';

export class TtOption extends LitElement {
  static styles = styles;

  static shadowRootOptions = {
    ...LitElement.shadowRootOptions,
    delegatesFocus: true,
  };

  @property({ type: Boolean })
  disabled = false;

  @property({ type: Boolean })
  selected = false;

  @property({ type: Boolean })
  active = false;

  @property({ type: String })
  value = '';

  @property({ type: Boolean, attribute: 'include-checkbox' })
  includeCheckbox = false;

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('click', this._onClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this._onClick);
  }

  private _onClick = (event: MouseEvent) => {
    if (this.disabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
    }
  };

  render() {
    return html`
      <li
        role="option"
        aria-selected="${this.selected}"
        aria-disabled="${this.disabled}"
        ?aria-hidden="${this.hidden}"
        data-active="${this.active}"
        data-value="${this.value}"
        @click="${this._onClick}"
        @mousedown="${(event: MouseEvent) => event.preventDefault()}"
        part="option"
      >
        ${this.includeCheckbox
          ? html`<input type="checkbox" ?checked=${this.selected} role="presentation" tabindex="-1" part="checkbox" />`
          : nothing}
        <span>
          <slot></slot>
        </span>
      </li>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tt-option': TtOption;
  }
}
